import { NkrEntityType, VendorType, ShipVendor, PhlebotVendor } from './enums';

/**
 * Get vendor name from vendor ID
 */
export const getVendorName = (
    vendorId: number, 
    shipVendors: { id: number; description: string; }[],
    vendorType?: number
): string => {
    // If this is a phlebotomy vendor (vendorType = 1)
    if (vendorType === VendorType.PHLEBOT) {
        // Use the PhlebotVendor enum
        return PhlebotVendor[vendorId] || `Unknown (${vendorId})`;
    }
    
    // Otherwise use the shipVendors list (for kit vendors)
    const vendor = shipVendors.find(v => v.id === vendorId);
    return vendor ? vendor.description : `Unknown (${vendorId})`;
};

/**
 * Get entity type name with proper formatting
 */
export const getEntityTypeName = (entityType: number): string => {
    const enumName = NkrEntityType[entityType];
    if (!enumName) return `Unknown (${entityType})`;
    
    // Format the enum name for display
    
    switch (enumName) {
        case 'DASH':
            return 'PWL';
        case 'HOME_BLOOD_DRAW':
            return 'HBD';
        case 'STREAMLINED_SEROLOGY':
            return 'S Serology';
        case 'DONOR_CHEEK_SWAB_ORDER':
            return 'Cheek Swab';
        case 'RECP_CHEEK_SWAB_ORDER':
            return 'Cheek Swab';
        case 'ANTIBODY_SCREENING':
            return 'Antibody';
        case 'XM_TRACKING':
            return 'XM';
        case 'SEROLOGY_TRACKING':
            return 'D Serology';
        case 'CENTER_BULK_CHEEK_SWAB':
            return 'Bulk Cheek';
        case 'STRONG_BOX':
            return 'SB';
        case 'STRONG_BOX_OPO':
            return 'SB OPO';
        default:
            // Convert snake_case to Title Case
            return enumName
                .toLowerCase()
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
    }
};

/**
 * Get vendor type name with proper formatting
 */
export const getVendorTypeName = (vendorType: number): string => {
    const enumName = VendorType[vendorType];
    if (!enumName) return `Unknown (${vendorType})`;
    
    // Format the enum name for display
    switch (enumName) {
        case 'KIT':
            return 'Kit';
        case 'PHLEBOT':
            return 'Phlebotomy';
        default:
            return enumName.charAt(0).toUpperCase() + enumName.slice(1).toLowerCase();
    }
};